import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Departement } from 'src/app/models/Departement';
import { depbyregion } from 'src/app/models/depByRgion';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DepartementService {

 

  PATH_ALL_DEPARTEMENTS = "/programmes-lots/departements/all";
  PATH_ALL_DEPARTEMENTS_BY_REGION = "/programmes-lots/departements/by-region/"
 // PATH_ALL_DEPARTEMENTS_BY_REGION="/departements/by-region/
  constructor(private http: HttpClient) { }
  
  getAllDepartement = (): Observable<Departement[]> => {
    let url = environment.host.domaine + this.PATH_ALL_DEPARTEMENTS;
    return this.http.get<Departement[]>(url)
  }

  getAllDepartementsByRegion = (code: number): Observable<depbyregion[]> => {
    let url = environment.host.domaine + this.PATH_ALL_DEPARTEMENTS_BY_REGION;
    return this.http.get<depbyregion[]>(url+code)
  }

  


}
